import { render } from "./Staffs.vue?vue&type=template&id=30b11e6f&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"

import "./Staffs.vue?vue&type=style&index=0&id=30b11e6f&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-30b11e6f"

export default script